import { render } from "./page_06.vue?vue&type=template&id=06640f62"
import script from "./page_06.vue?vue&type=script&lang=js"
export * from "./page_06.vue?vue&type=script&lang=js"
script.render = render

export default script